import React from 'react'
import BaseYouMayAlsoLikeTile from './BaseYouMayAlsoLikeTile'
import ProductTypeLabel from 'components/Luxkit/Label/ProductTypeLabel'
import FormatCurrency from 'components/Common/FormatCurrency'
import { pluralizeToString } from 'lib/string/pluralize'
import OfferUrgencyLabels from 'components/Common/Labels/OfferUrgencyLabels'
import Caption from 'components/Luxkit/Typography/Caption'
import PriceRowPrice from 'components/Luxkit/PricePoints/PriceRowPrice'
import PriceRowPriceCaption from 'components/Luxkit/PricePoints/PriceRowPriceCaption'

interface Props {
  offer: App.OfferSummary;
}

function TourYouMayAlsoLikeTile({ offer }: Props) {
  const pkg = offer.lowestPricePackage!
  const shouldShowValue = pkg ? pkg.shouldDisplayValue && pkg.value > pkg.price : false

  return (
    <BaseYouMayAlsoLikeTile
      image={offer.image}
      location={offer.location}
      title={offer.name}
      walledGarden={offer.walledGarden}
    >
      <BaseYouMayAlsoLikeTile.ImageBadges>
        <ProductTypeLabel productType={offer.productType} />
      </BaseYouMayAlsoLikeTile.ImageBadges>
      <BaseYouMayAlsoLikeTile.ContentTags>
        <OfferUrgencyLabels offer={offer} />
      </BaseYouMayAlsoLikeTile.ContentTags>
      <BaseYouMayAlsoLikeTile.PriceDetails>
        <PriceRowPriceCaption>
          {pluralizeToString('day', pkg.duration)} from
        </PriceRowPriceCaption>
        <PriceRowPrice
          size="M"
          price={Math.ceil(pkg.price)}
          saleUnit={`person • ${pkg.roomOccupancy}`}
          taxesAndFees={pkg.taxesAndFees}
        />
        {shouldShowValue && (
          <Caption variant="medium">Valued up to <FormatCurrency value={Math.ceil(pkg.value)} /></Caption>
        )}
      </BaseYouMayAlsoLikeTile.PriceDetails>
    </BaseYouMayAlsoLikeTile>
  )
}

export default TourYouMayAlsoLikeTile
